<template>
  <v-app>
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </v-app>
</template>

<script>

import ImageTransferApp from '@/views/ImageTransferApp'
import HelpComponent from '@/views/Help'

export default {
  name: 'App',
  components: {
    ImageTransferApp,
    HelpComponent
  },
  data () {
    return {
      //
    }
  }
}
</script>
